<template>
  <div class="w-full flex flex-col mb-2 relative">
    <!-- Label -->
    <label
      :for="id"
      :class="[
        'mb-1 font-medium text-sm',
        disable ? 'text-gray-300' : 'text-gray-600'
      ]"
    >
      {{ placeholder }}
      <span v-if="required && !disable" class="text-red-600">*</span>
    </label>

    <!-- Upload Box -->
    <div
      class="flex items-center border-2 rounded-md bg-white min-h-[40px] focus-within:ring-2 focus-within:ring-theme-primary"
    >
      <!-- Filename -->
      <div class="flex-1 px-3 truncate" :class="fileName ? 'text-gray-700' : 'text-gray-400'">
        {{ fileName || "No file selected" }}
      </div>

      <!-- Hidden File Input -->
      <input
        ref="fileInput"
        :id="id"
        type="file"
        class="hidden"
        :accept="accept"
        :disabled="disable"
        @change="onFileChange"
      />

      <!-- Browse Button -->
      <button
        type="button"
        @click="$refs.fileInput.click()"
        :disabled="disable"
        class="px-4 h-[40px] border-l bg-theme-primary text-white hover:opacity-90 disabled:bg-gray-300"
      >
        Browse
      </button>

      <!-- Clear Button -->
      <button
        type="button"
        @click="clearFile"
        :disabled="disable || !selectedFile"
        class="px-4 h-[40px] border-l bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:text-gray-400"
      >
        Clear
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "FileUploadControl",

  props: {
    id: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: "Upload File"
    },
    required: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ""
    }
  },

  emits: ["update:file"],

  data() {
    return {
      selectedFile: null
    };
  },

  computed: {
    fileName() {
      return this.selectedFile ? this.selectedFile.name : "";
    }
  },

  methods: {
    onFileChange(event) {
      const file = event.target.files[0];

      if (!file) return;

      this.selectedFile = file;

      const reader = new FileReader();

      reader.onload = () => {
        this.$emit("update:file", {
          file,
          base64: reader.result // data:application/pdf;base64,...
        });
      };

      reader.readAsDataURL(file);
    },

    clearFile() {
      this.selectedFile = null;
      this.$refs.fileInput.value = "";
      this.$emit("update:file", null);
    }
  }
});
</script>